import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import './media/terminalQuickFix.css.js';
import { DisposableStore } from 'vscode/vscode/vs/base/common/lifecycle';
import { localize2WithPath } from 'vscode/vscode/vs/nls';
import { IInstantiationService } from 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { registerActiveInstanceAction } from '../../../terminal/browser/terminalActions.js';
import { registerTerminalContribution } from '../../../terminal/browser/terminalExtensions.js';
import { TerminalContextKeys } from 'vscode/vscode/vs/workbench/contrib/terminal/common/terminalContextKey';
import { TerminalQuickFixAddon } from './quickFixAddon.js';
import { gitTwoDashes, gitPull, freePort, gitSimilar, gitPushSetUpstream, gitCreatePr, pwshUnixCommandNotFoundError, pwshGeneralError } from './terminalQuickFixBuiltinActions.js';
import './terminalQuickFixService.js';

var TerminalQuickFixContribution_1;
const _moduleId = "vs/workbench/contrib/terminalContrib/quickFix/browser/terminal.quickFix.contribution";
let TerminalQuickFixContribution = class TerminalQuickFixContribution extends DisposableStore {
    static { TerminalQuickFixContribution_1 = this; }
    static { this.ID = 'quickFix'; }
    static get(instance) {
        return instance.getContribution(TerminalQuickFixContribution_1.ID);
    }
    get addon() { return this._addon; }
    constructor(_instance, processManager, widgetManager, _instantiationService) {
        super();
        this._instance = _instance;
        this._instantiationService = _instantiationService;
    }
    xtermReady(xterm) {
        this._addon = this._instantiationService.createInstance(TerminalQuickFixAddon, undefined, this._instance.capabilities);
        xterm.raw.loadAddon(this._addon);
        this.add(this._addon.onDidRequestRerunCommand((e) => this._instance.runCommand(e.command, e.shouldExecute || false)));
        for (const actionOption of [
            gitTwoDashes(),
            gitPull(),
            freePort((port, command) => this._instance.freePortKillProcess(port, command)),
            gitSimilar(),
            gitPushSetUpstream(),
            gitCreatePr(),
            pwshUnixCommandNotFoundError(),
            pwshGeneralError()
        ]) {
            this._addon.registerCommandFinishedListener(actionOption);
        }
    }
};
TerminalQuickFixContribution = TerminalQuickFixContribution_1 = ( (__decorate([
    ( (__param(3, IInstantiationService)))
], TerminalQuickFixContribution)));
registerTerminalContribution(TerminalQuickFixContribution.ID, TerminalQuickFixContribution);
registerActiveInstanceAction({
    id: "workbench.action.terminal.showQuickFixes" ,
    title: ( localize2WithPath(_moduleId, 0, 'Show Terminal Quick Fixes')),
    precondition: TerminalContextKeys.focus,
    keybinding: {
        primary: 2048  | 89 ,
        weight: 200
    },
    run: (activeInstance) => TerminalQuickFixContribution.get(activeInstance)?.addon?.showMenu()
});
